export const integrationRoutes = {
  default: 'integration-home',
  settings: 'integration-settings',
  appPermissions: 'integration_app_permissions',
  appUpgradePlans: 'integration_app_upgrade_plans',
  appVersion: 'integration_app_version', 
  updateApp: 'integration_update_app',
  notFound: 'integration_not_found',
  appAnyApp: 'integration_app_any_app',
}
